export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7024.35af3f28.jpg";